import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useLayoutOptions } from '../layout-options-provider';
import Portal from '../portal';
type StickyBottomBoxProps = {
  children: React.ReactNode;
};
const StickyBottomBox = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    bottomActionBoxPortalId
  } = useLayoutOptions();
  const t1 = `#${bottomActionBoxPortalId}`;
  let t2;
  if ($[0] !== children) {
    t2 = <div className="flex flex-col p-4 bg-primary md:px-6 md:py-4">{children}</div>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Portal selector={t1}>{t2}</Portal>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default StickyBottomBox;